export type VMenuTheme = 'primary' | 'secondary';

const getTextColor = (theme?: VMenuTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'text-white';
    default:
      return 'text-primary-900';
  }
};

const getSubmenuheaderTextColor = (theme?: VMenuTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'text-white/50';
    default:
      return 'text-primary-900';
  }
};

const getBackgroundColor = (theme?: VMenuTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'bg-menu';
    case 'secondary':
      return 'bg-grey-100';
    default:
      return 'bg-white';
  }
};

const getActiveBackgroundColor = (theme?: VMenuTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'bg-primary-600';
    case 'secondary':
      return 'bg-grey-200';
    default:
      return 'bg-grey-100';
  }
};

const getHoverColor = (theme?: VMenuTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'hover:bg-white/25';
    case 'secondary':
      return 'hover:bg-grey-200';
    default:
      return 'hover:bg-grey-100';
  }
};

export const getStylesObj = (theme?: VMenuTheme | undefined) => ({
  textColor: getTextColor(theme),
  submenuLabelTextColor: getSubmenuheaderTextColor(theme),
  bgColor: getBackgroundColor(theme),
  activeBgColor: getActiveBackgroundColor(theme),
  hoverColor: getHoverColor(theme),
});
